import image1 from "@/common/assets/image/moneyFortune/QAimage/image1.webp"
import image2 from "@/common/assets/image/moneyFortune/QAimage/image2.webp"
import image3 from "@/common/assets/image/moneyFortune/QAimage/image3.webp"
import image4 from "@/common/assets/image/moneyFortune/QAimage/image4.webp"

export const resultRoleJudge = (resultMarks1, resultMarks2) => {
  switch (true) {
    case resultMarks1 < 8 && resultMarks2 < 8:
      return "Oldman"
      break
    case resultMarks1 < 6 && resultMarks2 < 13:
      return "Loser"
      break
    case resultMarks1 < 13 && resultMarks2 < 6:
      return "DoKwon"
      break
    case resultMarks1 < 10 && resultMarks2 < 10:
      return "SuperRich"
      break
    case resultMarks1 < 10 && resultMarks2 < 13:
      return "V"
      break
    case resultMarks1 < 13 && resultMarks2 < 13:
      return "Musk"
      break
    case resultMarks1 + resultMarks2 < 200:
      return "Amber"
      break
    case resultMarks1 + resultMarks2 < 1000:
      return "ARK"
      break
    case resultMarks1 + resultMarks2 < 10000:
      return "Jeff"
      break
    case resultMarks1 + resultMarks2 < 100000:
      return "Bitcoin"
      break
    default:
      return ""
      break
  }
}

export const getTraitId = role => {
  switch (role) {
    case "Loser":
      return "9"
    case "Bitcoin":
      return "1"
    case "DoKwon":
      return "10"
    case "Oldman":
      return "6"
    case "Amber":
      return "7"
    case "ARK":
      return "8"
    case "V":
      return "2"
    case "Jeff":
      return "5"
    case "SuperRich":
      return "3"
    case "Musk":
      return "4"
    default:
      return "11"
  }
}

export const QuestionsData = [
  {
    number: 1,
    question: "用你的直覺，選擇一張未來最有潛力 NFT",
    type: "Image",
    answers: [
      { count1: 0, count2: 0, content: "1", img: image1 },
      { count1: 0, count2: 0, content: "2", img: image2 },
      { count1: 0, count2: 0, content: "3", img: image3 },
      { count1: 0, count2: 0, content: "4", img: image4 }
    ]
  },
  {
    number: 2,
    question: "投資區塊鏈你會比較傾向哪個做法?",
    type: "word",
    answers: [
      {
        count1: 0,
        count2: 1,
        content: "投資公認且有潛力的加密貨幣像是比特幣、乙太幣等"
      },
      {
        count1: 80000,
        count2: 3,
        content: "與其幫別人捧幣，不如自己重新打造一個鏈"
      },
      {
        count1: 0,
        count2: 2,
        content: "投資藝術家的NFT或是鏈遊的寶物 經營賺錢"
      }
    ]
  },
  {
    number: 3,
    question: "在你的人生裡，一次性最多賺／賠過多少錢？",
    type: "word",
    answers: [
      { count1: 1, count2: 0, content: "哪來的錢？一千塊以下" },
      { count1: 2, count2: 0, content: "一千以上到百萬" },
      { count1: 3, count2: 0, content: "錢多我驕傲，百萬以上" }
    ]
  },

  {
    number: 4,
    question: "你認為自己是在區塊鏈圈是怎麼樣的角色？",
    type: "word",
    answers: [
      { count1: 1, count2: 0, content: "正在學習，小白一個" },
      { count1: 3, count2: 0, content: "挖礦炒幣，資深玩家" },
      { count1: 8000, count2: 0, content: "投資高手，大割別人😈" }
    ]
  },
  {
    number: 5,
    question: "你相信在未來 10 年內 Web3.0 的世界（一級玩家）會到來嗎？",
    type: "word",
    answers: [
      { count1: 0, count2: 1, content: "醒醒吧，元宇宙只是一場夢" },
      { count1: 1, count2: 2, content: "正在起飛了，進場中" },
      { count1: 0, count2: 3, content: "客觀看待，10年內革新宇宙" }
    ]
  },
  {
    number: 6,
    question: "某天醒來，你發現錢包裡突然收到 200 顆比特幣，你會怎麼做？",
    type: "word",
    answers: [
      { count1: 1, count2: 0, content: "HODL，放在錢包等增值" },
      { count1: 800, count2: 0, content: "轉成現金資產，改投資美股ETF" },
      { count1: 2, count2: 1, content: "拿去創業，槓桿翻倍" }
    ]
  },
  {
    number: 7,
    question: "財務計畫上，最常做的事情是什麼？",
    type: "word",
    answers: [
      { count1: 0, count2: 3, content: "自立自強，FOMO 新資訊學投資" },
      { count1: 0, count2: 80, content: "躺平為上，靠另外一半賺錢" },
      { count1: 1, count2: 2, content: "信任為上，把錢交給投資專家" }
    ]
  },
  {
    number: 8,
    question:
      "「最好的朋友」跟你說現在有個賺大錢的機會，20 萬投下去馬上翻倍，你願意把錢拿出來投資嗎？",
    type: "word",
    answers: [
      { count1: 0, count2: 1, content: "不相信有賺大錢的機會，直接說不" },
      {
        count1: 2,
        count2: 2,
        content: "ALL IN！相信朋友全押了"
      },
      {
        count1: 0,
        count2: 3,
        content: "DYOR 查找資料做研究，評估自己閒置資產再投資"
      }
    ]
  },
  {
    number: 9,
    question: "投資報酬率幾 % 以上的金融商品，你會願意出錢投資？",
    type: "word",
    answers: [
      { count1: 1, count2: 0, content: "跟銀行差不多就可以" },
      { count1: 2, count2: 0, content: "15%以上我願意挑戰" },
      { count1: 3, count2: 0, content: "5-7% 合理範圍" }
    ]
  }
]
